import { useParams } from 'react-router-dom';

const useOrgUnitIdFromURL = () => {
  const { orgUnit } = useParams();
  return parseInt(orgUnit);
};

export default useOrgUnitIdFromURL;
